import { CustomInputMapping } from "../..";
import { getContactFields } from "./contactFields";
import { getCompanyFields } from "./companyFields";

type T = (key: string) => string;
const fixedT: T = (key) => key;
export const getDefaultDataTypes = (tFunc?: T, onlyT?: boolean): CustomInputMapping[] => {
  const t = tFunc ? tFunc : fixedT;
  return [
    {
      title: onlyT ? t("Post") : t("inputTypes:Post"),
      icon: "subject",
      customDataMapping: {
        dataTypeFilter: "post",
        structureJson: "",
        customFieldsMappings: [
          {
            toAggregate: false,
            sourceField: "post_field",
            aggregateField: "post_field",
            fieldName: "Post message",
            fieldDescription: null,
            fieldIcon: null,
            automaticTitleOrder: 1,
            unit: "post_field",
            type: "paragraph",
            dataType: null,
            options: null,
            fieldOrder: 1,
            required: true,
          },
        ],
      },
      enablePublishingToPublicFeed: false,
      isEveryoneCanEdit: true,
      isEnableRating: false,
      isEnableLocation: false,
      isAutomaticTitle: true,
      isEnableFiles: true,
      isEnableDueDate: true,
      isDueDateMandatory: false,
    },
    {
      title: onlyT ? t("Media") : t("inputTypes:Media"),
      icon: "camera_roll",
      customDataMapping: {
        dataTypeFilter: "media",
        structureJson: "",
        customFieldsMappings: [
          {
            toAggregate: false,
            sourceField: "post_field",
            aggregateField: "post_field",
            fieldName: "Post message",
            fieldDescription: null,
            fieldIcon: null,
            automaticTitleOrder: 1,
            unit: "post_field",
            type: "paragraph",
            dataType: null,
            options: null,
            fieldOrder: 1,
            required: true,
          },
        ],
      },
      enablePublishingToPublicFeed: false,
      isEveryoneCanEdit: true,
      isEnableRating: false,
      isEnableLocation: false,
      isAutomaticTitle: true,
      isEnableFiles: true,
      isEnableDueDate: true,
      isDueDateMandatory: false,
    },
    {
      title: onlyT ? t("File") : t("inputTypes:File"),
      icon: "attach_file",
      customDataMapping: {
        dataTypeFilter: "file",
        structureJson: "",
        customFieldsMappings: [
          {
            toAggregate: false,
            sourceField: "post_field",
            aggregateField: "post_field",
            fieldName: "Post message",
            fieldDescription: null,
            fieldIcon: null,
            automaticTitleOrder: 1,
            unit: "post_field",
            type: "paragraph",
            dataType: null,
            options: null,
            fieldOrder: 1,
            required: true,
          },
        ],
      },
      enablePublishingToPublicFeed: false,
      isEveryoneCanEdit: true,
      isEnableRating: false,
      isEnableLocation: false,
      isAutomaticTitle: true,
      isEnableFiles: true,
      isEnableDueDate: true,
      isDueDateMandatory: false,
    },
    {
      title: onlyT ? t("Event") : t("inputTypes:Event"),
      icon: "event",
      customDataMapping: {
        dataTypeFilter: "event",
        structureJson: "",
        customFieldsMappings: [
        ],
      },
      enablePublishingToPublicFeed: false,
      isEveryoneCanEdit: true,
      isEnableRating: false,
      isEnableLocation: false,
      isAutomaticTitle: false,
      isEnableFiles: false,
      isEnableDueDate: true,
      isDueDateMandatory: false,
    },
    {
      title: onlyT ? t("Code") : t("inputTypes:Code"),
      icon: "code",
      customDataMapping: {
        dataTypeFilter: "code",
        structureJson: "",
        customFieldsMappings: [
        ],
      },
      enablePublishingToPublicFeed: false,
      isEveryoneCanEdit: true,
      isEnableRating: false,
      isEnableLocation: false,
      isAutomaticTitle: false,
      isEnableFiles: false,
      isDueDateMandatory: false,
      isEnableDueDate: true,
    },
    {
      title: onlyT ? t("Mail") : t("inputTypes:Mail"),
      icon: "mail",
      customDataMapping: {
        dataTypeFilter: "mail",
        structureJson: "",
        customFieldsMappings: [
        ],
      },
      enablePublishingToPublicFeed: false,
      isEveryoneCanEdit: true,
      isEnableRating: false,
      isEnableLocation: false,
      isAutomaticTitle: false,
      isEnableFiles: false,
      isEnableDueDate: true,
      isDueDateMandatory: false,
    },
    {
      title: onlyT ? t("Link") : t("inputTypes:Link"),
      icon: "link",
      customDataMapping: {
        dataTypeFilter: "bookmark",
        structureJson: "",
        customFieldsMappings: [
          {
            toAggregate: false,
            sourceField: "post_field",
            aggregateField: "post_field",
            fieldName: "Post message",
            fieldDescription: null,
            fieldIcon: null,
            automaticTitleOrder: 1,
            unit: "post_field",
            type: "paragraph",
            dataType: null,
            options: null,
            fieldOrder: 1,
            required: true,
          },
        ],
      },
      enablePublishingToPublicFeed: false,
      isEveryoneCanEdit: true,
      isEnableRating: false,
      isEnableLocation: false,
      isAutomaticTitle: true,
      isEnableFiles: false,
      isEnableDueDate: true,
      isDueDateMandatory: false,
    },
    {
      title: onlyT ? t("Poll") : t("inputTypes:Poll"),
      icon: "poll",
      customDataMapping: {
        dataTypeFilter: "poll",
        structureJson: "",
        customFieldsMappings: [
          {
            toAggregate: false,
            sourceField: "poll_field",
            aggregateField: "poll_field",
            fieldName: "Poll message",
            fieldDescription: null,
            fieldIcon: null,
            unit: "poll_field",
            type: "paragraph",
            dataType: null,
            options: null,
            fieldOrder: 1,
            required: true,
          },
        ],
      },
      enablePublishingToPublicFeed: false,
      isEveryoneCanEdit: true,
      isEnableLocation: false,
      isAutomaticTitle: false,
      isEnableRating: false,
      isEnableFiles: false,
      isEnableDueDate: true,
      isDueDateMandatory: false,
    },
    {
      title: onlyT ? t("Location") : t("inputTypes:Location"),
      icon: "location_on",
      customDataMapping: {
        dataTypeFilter: "location",
        structureJson: "",
        customFieldsMappings: [
          {
            toAggregate: false,
            sourceField: "location_field",
            aggregateField: "location_field",
            fieldName: "Add Location",
            fieldDescription: null,
            fieldIcon: null,
            unit: "location_field",
            type: "location",
            dataType: null,
            options: null,
            fieldOrder: 1,
            required: true,
          },
        ],
      },
      enablePublishingToPublicFeed: false,
      isEveryoneCanEdit: true,
      isEnableLocation: true,
      isAutomaticTitle: false,
      isEnableFiles: false,
      isEnableRating: false,
      isEnableDueDate: true,
      isDueDateMandatory: false,
    },
    {
      title: onlyT ? t("Company") : t("inputTypes:Company"),
      icon: "business",
      customDataMapping: {
        dataTypeFilter: "company",
        structureJson: "",
        customFieldsMappings: getCompanyFields(t),
      },
      enablePublishingToPublicFeed: true,
      isEveryoneCanEdit: true,
      isEnableLocation: false,
      isAutomaticTitle: false,
      isEnableRating: false,
      isEnableFiles: false,
      isEnableDueDate: true,
      isDueDateMandatory: false,
    },
    {
      title: onlyT ? t("Contact") : t("inputTypes:Contact"),
      icon: "account_circle",
      customDataMapping: {
        dataTypeFilter: "contact",
        structureJson: "",
        customFieldsMappings: getContactFields(t),
      },
      enablePublishingToPublicFeed: true,
      isEveryoneCanEdit: true,
      isEnableLocation: false,
      isAutomaticTitle: false,
      isEnableRating: false,
      isEnableFiles: false,
      isEnableDueDate: true,
      isDueDateMandatory: false,
    },
  ];
};
